module.exports = __webpack_public_path__ + "img/lines_orange.37b7c865.png";